import { requireAnyOrgPermission, requireAnySystemPermission } from '../../../../../../backend/features/permissions/shared';
import { AccountSlideout, useAccountsTable, } from '../../../../../../ui/features/accounts';
import { useUserState } from '../../../../../../ui/hooks';
import { DataTable, useDataTableUsingUrl } from '@juvare/common-data-table-ui/DataTable';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { Box } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router';
import { AccountsIManageSwitch, showAccountsIManageFilterName } from '../../../../accounts/components/AccountsIManageSwitch';
import { useOrganizationMembersTableActions } from '../hooks';
export const OrganizationMembers = (props) => {
    var _a;
    const settings = useSelector(getSettings);
    const userState = useUserState();
    const [searchParams] = useSearchParams();
    const location = {
        name: 'org-members',
        organizationId: props.organizationId,
    };
    const { dataTableProps, appliedFilterData, clearActiveRow, reload } = useAccountsTable({
        rowSelectionEnabled: true,
        showAccountStatusFilter: 'quickFilter',
        useDataTableFunction: useDataTableUsingUrl,
        onRowClick: () => undefined,
        location: location,
        showOrganizationRoleFilter: 'quickFilter',
        showOrganizationStatusFilter: 'quickFilter',
        staticStorageClientFilter: [
            {
                column: 'orgStatus',
                op: 'overlap',
                value: Object.entries(settings.orgStatusMap).map(([value]) => `${props.organizationId}_${value}`),
            },
        ],
        showAccountsIManage: searchParams.get(showAccountsIManageFilterName) === 'true',
        defaultRowsPerPage: 100,
    });
    const rowCount = dataTableProps.selectedRowIds && dataTableProps.selectedRowIds.length > 0
        ? dataTableProps.selectedRowIds.length
        : ((_a = dataTableProps.filteredRowCount) !== null && _a !== void 0 ? _a : 0);
    const { globalActions, localActions } = useOrganizationMembersTableActions({
        dataTableProps,
        appliedFilterData,
        rowCount,
        organizationId: props.organizationId,
        onReloadOrganization: props.onReloadOrganization,
        onReloadTable: reload,
    });
    return (React.createElement(Box, null,
        React.createElement(Box, { sx: { p: 2 } },
            React.createElement(DataTable, Object.assign({}, dataTableProps, { globalActions: globalActions, localActions: localActions, customHeaderElement: !requireAnySystemPermission(userState, 'manage-accounts') &&
                    requireAnyOrgPermission(userState, 'manage-members') ? (React.createElement(AccountsIManageSwitch, null)) : undefined }))),
        React.createElement(AccountSlideout, { accountId: dataTableProps.activeRowId, onClose: (changed) => {
                clearActiveRow();
                if (changed) {
                    reload();
                }
            }, customMenuItems: props.customMemberSlideoutMenuItems, customDetailsComponent: props.customMemberDetailsComponent, accountListReload: reload })));
};
